export default "__VITE_ASSET__CAaqkZZe__"